export const generateUserDisplayName = (
  user: { profile: { firstName: string, lastName: string } },
  emailFallback = '',
): string => {
  return user?.profile?.firstName
    ? `${user.profile?.firstName}${user.profile?.lastName ? ` ${user.profile?.lastName}` : ''}`
    : emailFallback;
};
